import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';
import { useTranslation } from 'react-i18next';
const PlanDetailsSkeleton = () => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="d-block d-md-block col-md-12 col-lg-6 p-0 m-auto"
        aria-label="Details of Spending Summary"
      >
        <h3 className="spending-summary">
          {t('member.dashboard.spending.summary_title')}
        </h3>
        <span id="hsa-member-id">
          <Skeleton />
        </span>
        <Skeleton />
        <div className="avail-bal">
          <Skeleton />
        </div>
        <Skeleton />

        <Row className="clear-both">
          <Col>
            <Skeleton />
          </Col>
        </Row>

        <Row className="clear-both">
          <Col>
            <Skeleton />
          </Col>
        </Row>
      </div>
      {/*Mobile className="d-block d-md-none col-xs-12 col-sm-12 p-0"*/}

      <Col className="d-none d-lg-block col-lg-6 m-auto">
        <div className={'mt-3'}>
          <Skeleton count={4} />
        </div>
      </Col>
    </>
  );
};

export default PlanDetailsSkeleton;
